import axios from 'axios'
import { API_URL } from '../../../../modules/auth/core/_requests'
import { ShippingOrder } from '../DeShippingTableWrapper'

export async function getOrders(): Promise<ShippingOrder[]> {
  try {
    const response = await axios.get(`${API_URL}/api/shopify-shipping/dashboard/orders`)
    console.log('Orders fetched:', response.data[0])
    return response.data
  } catch (error) {
    if (axios.isAxiosError(error)) {
      if (error.response) {
        throw new Error(error.response.data?.error || 'Failed to fetch orders')
      } else {
        throw new Error('Network error when fetching orders')
      }
    }
    throw error
  }
}

export async function getOrderById(orderId: string): Promise<ShippingOrder> {
  try {
    const response = await axios.get(`${API_URL}/api/shopify-shipping/dashboard/orders/order-data/${orderId}`)
    
    if (!response.data.success) {
      throw new Error(response.data.error || 'Failed to fetch order')
    }
    
    return response.data.data
  } catch (error) {
    if (axios.isAxiosError(error)) {
      if (error.response) {
        throw new Error(error.response.data?.error || 'Failed to fetch order')
      } else {
        throw new Error('Network error when fetching order')
      }
    }
    throw error
  }
}